const Multiline = ({ text }) => {
  return (
    <>
      {text?.split('\n').map((line, index) => (
        <div key={`line-${index}`}>{line}</div>
      ))}
    </>
  )
}

export default Multiline
